import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DatepickerService {
  public translations = {
    'de': {
      apply: 'Anwenden',
      months: [ 'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember' ],
      monthsShort: [ 'Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez' ],
      weekdaysFull: [ 'Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag' ],
      days: [ 'So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa' ],
      today: 'Heute',
      clear: 'Löschen',
      close: 'Schließen',
      firstDay: 1,
      format: 'dddd, dd. mmmm yyyy',
      formatSubmit: 'yyyy/mm/dd'
    },
    'da': {
      apply: 'Vælg',
      months: [ 'januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december' ],
      monthsShort: [ 'jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec' ],
      weekdaysFull: [ 'søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag' ],
      days: [ 'søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør' ],
      today: 'i dag',
      clear: 'slet',
      close: 'luk',
      firstDay: 1,
      format: 'd. mmmm yyyy',
      formatSubmit: 'yyyy/mm/dd'
    },
    'en': {
      // English support is already built-in as the default, no additional translations needed.
      apply: 'Apply',
      monthsShort: [ 'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec' ],
      today: 'today',
      clear: 'clear',
      close: 'close',
      firstDay: 1
    },
    'fi': {
      apply: 'Tallenna',
      months: [ 'tammikuu', 'helmikuu', 'maaliskuu', 'huhtikuu', 'toukokuu', 'kesäkuu', 'heinäkuu', 'elokuu', 'syyskuu', 'lokakuu', 'marraskuu', 'joulukuu' ],
      monthsShort: [ 'tammi', 'helmi', 'maalis', 'huhti', 'touko', 'kesä', 'heinä', 'elo', 'syys', 'loka', 'marras', 'joulu' ],
      weekdaysFull: [ 'sunnuntai', 'maanantai', 'tiistai', 'keskiviikko', 'torstai', 'perjantai', 'lauantai' ],
      days: [ 'su', 'ma', 'ti', 'ke', 'to', 'pe', 'la' ],
      today: 'tänään',
      clear: 'tyhjennä',
      firstDay: 1,
    },
    'no': {
      apply: 'Velg',
      months: [ 'januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember' ],
      monthsShort: [ 'jan', 'feb', 'mar', 'apr', 'mai', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'des' ],
      weekdaysFull: [ 'søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag' ],
      days: [ 'søn','man','tir', 'ons', 'tor', 'fre', 'lør' ],
      today: 'i dag',
      clear: 'nullstill',
      close: 'lukk',
      firstDay: 1,
    },
    'pl': {
      apply: 'apply',
      months: ['styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień'],
      monthsShort: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
      weekdaysFull: ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota'],
      days: ['niedz.', 'pn.', 'wt.', 'śr.', 'cz.', 'pt.', 'sob.'],
      today: 'Dzisiaj',
      clear: 'Usuń',
      close: 'Zamknij',
      firstDay: 1,
      format: 'd mmmm yyyy',
      formatSubmit: 'yyyy/mm/dd'
    },
    'ru': {
      apply: 'apply',
      months: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'],
      monthsShort: ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
      weekdaysFull: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
      days: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
      today: 'сегодня',
      clear: 'удалить',
      close: 'закрыть',
      firstDay: 1,
      format: 'd mmmm yyyy г.',
      formatSubmit: 'yyyy/mm/dd'
    },
    'sv': {
      apply: 'Tillämpa',
      months: ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december'],
      monthsShort: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
      weekdaysFull: ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag'],
      days: ['sön', 'mån', 'tis', 'ons', 'tor', 'fre', 'lör'],
      today: 'Idag',
      clear: 'Rensa',
      close: 'Stäng',
      firstDay: 1,
    }
  };

  constructor() {}
}
